import { Component } from '@angular/core';
import { ReportShareComponent } from '../../report-share.component';

@Component({
  selector: 'app-coachee-style-expression',
  templateUrl: './coachee-style-expression.component.html'
})
export class CoacheeStyleExpressionComponent extends ReportShareComponent {

  get html(): string {
    return this.report?.styleExpressionDesc?.replaceAll('\n','<br />') ?? '';
  }

}
